import React from "react";
import {
  useApproveDeclineRatingScaleMutation,
  useGetSingleRatingQuery,
} from "../../../../../api/hrApi";
import PageLayout from "../../../../Components/Layout/PageLayout";
import { FormProvider } from "react-hook-form";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { FormTemplate } from "../../../../Components/Forms/InputTemplate";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import { useNavigate, useParams } from "react-router";
import { ApproveModals } from "../../../../Components/Modals/ApproveDeclineModals";
import { AppraisalDeclineModal } from "../Modals/DeclineModal";
import ApproveModal from "../Modals/ApproveModal";
import { toast } from "react-toastify";
import { getStatusText } from "../../../Finance/CostCenter/Class";

export const ViewSingleRatingScale = () => {
  const { id } = useParams();
  const { data } = useGetSingleRatingQuery(id);
  const navigation = useNavigate();
  const [approveDecline, { isLoading }] =
    useApproveDeclineRatingScaleMutation();
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openDeclineModal, setOpenDeclineModal] = React.useState(false);
  const [comment, setComment] = React.useState("");
    const declineVariable = 1;
  const approveVaiable = 0;
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const declineAction = async (type) => {
    if (!comment && type === 1) {
      toast.error("Please enter a comment");
      return;
    }
    try {
      const response = await approveDecline({
        id,
        comment,
        approvalType: type,
      }).unwrap();
      if (response?.successful) {
        setOpenDeclineModal(false);
        setOpenApproveModal(false);
        toast.success(response?.statusMessage);
        navigation("/dashboard/hr/HR-Appraisal-Setup/rating-scale");
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage);
    }
  };

  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);

  return (
    <PageLayout title={"Rating Scale Details"} hasBack={true}>
      <div className={DashboardStyle.app_view_controls}></div>
      <FormProvider>
        <FormTemplate className={DashboardStyle.view_app_components}>
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(32.3%, 1fr))",
                  gap: "10px",
                }}
              >
                <div>
                  <p>Title:</p>
                  <h4>{data?.responseObject?.title}</h4>
                </div>
                <div>
                  <p>Date Initiated:</p>
                  <h4>
                    {data?.responseObject?.createdDate
                      ? new Date(
                          data.responseObject.createdDate
                        ).toLocaleDateString()
                      : "N/A"}
                  </h4>
                </div>
                <div>
                  <p>Approval Status:</p>
                  <h4>
                    {typeof data?.responseObject?.approvalStatus === "number"
                      ? getStatusText(data?.responseObject?.approvalStatus)
                      : data?.responseObject?.approvalStatus}
                  </h4>
                </div>
                <div>
                  <p>Scale Level:</p>
                  <h4>{data?.responseObject?.scaleLevel || 0}</h4>
                </div>
              </div>
            </div>
          </section>
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>Scale Levels</h4>
            <div className={DashboardStyle.labels_group}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                  gap: "16px",
                  marginTop: "16px",
                }}
              >
                {data?.responseObject?.scaleLevels?.map((item, _index) => {
                  // Function to get color badge style
                  const getColorBadgeStyle = (colorType) => {
                    const baseStyle = {
                      padding: "4px 12px",
                      borderRadius: "12px",
                      fontSize: "0.75rem",
                      fontWeight: "500",
                      display: "inline-block",
                      textTransform: "capitalize",
                    };

                    switch (colorType?.toLowerCase()) {
                      case "red":
                        return {
                          ...baseStyle,
                          backgroundColor: "#fee2e2",
                          color: "#dc2626",
                        };
                      case "yellow":
                        return {
                          ...baseStyle,
                          backgroundColor: "#fef3c7",
                          color: "#d97706",
                        };
                      case "green":
                        return {
                          ...baseStyle,
                          backgroundColor: "#dcfce7",
                          color: "#16a34a",
                        };
                      case "blue":
                        return {
                          ...baseStyle,
                          backgroundColor: "#dbeafe",
                          color: "#2563eb",
                        };
                      case "orange":
                        return {
                          ...baseStyle,
                          backgroundColor: "#fed7aa",
                          color: "#ea580c",
                        };
                      default:
                        return {
                          ...baseStyle,
                          backgroundColor: "#f3f4f6",
                          color: "#6b7280",
                        };
                    }
                  };

                  return (
                    <div
                      key={_index}
                      style={{
                        backgroundColor: "white",
                        border: "1px solid #e5e7eb",
                        borderRadius: "12px",
                        padding: "20px",
                        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                        position: "relative",
                      }}
                    >
                      {/* Level Header */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: "16px",
                        }}
                      >
                        <h5
                          style={{
                            fontSize: "1rem",
                            fontWeight: "600",
                            color: "#374151",
                            margin: 0,
                          }}
                        >
                          LEVEL {item?.scaleNumber || _index + 1}
                        </h5>
                        <div
                          style={{
                            position: "absolute",
                            top: "16px",
                            right: "16px",
                            color: "#9ca3af",
                            fontSize: "1.25rem",
                          }}
                        >
                          •••
                        </div>
                      </div>

                      {/* Scale Information */}
                      <div style={{ marginBottom: "12px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "0.875rem",
                              color: "#6b7280",
                              minWidth: "100px",
                            }}
                          >
                            Scale Title
                          </span>
                          <span
                            style={{
                              fontSize: "0.875rem",
                              color: "#374151",
                              fontWeight: "500",
                            }}
                          >
                            {item?.scaleTitle || "N/A"}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "0.875rem",
                              color: "#6b7280",
                              minWidth: "100px",
                            }}
                          >
                            Scale Number
                          </span>
                          <span
                            style={{
                              fontSize: "0.875rem",
                              color: "#374151",
                              fontWeight: "500",
                            }}
                          >
                            {item?.scaleNumber ?? "N/A"}
                          </span>
                          <span
                            style={{
                              fontSize: "0.75rem",
                              color: "#9ca3af",
                              marginLeft: "8px",
                            }}
                          >
                            Needs Improvement
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "12px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "0.875rem",
                              color: "#6b7280",
                              minWidth: "100px",
                            }}
                          >
                            Color
                          </span>
                          <span style={getColorBadgeStyle(item?.colorType)}>
                            {item?.colorType || "N/A"}
                          </span>
                        </div>

                        <div>
                          <span
                            style={{
                              fontSize: "0.875rem",
                              color: "#6b7280",
                              display: "block",
                              marginBottom: "4px",
                            }}
                          >
                            Description
                          </span>
                          <p
                            style={{
                              fontSize: "0.875rem",
                              color: "#6b7280",
                              margin: 0,
                              lineHeight: "1.4",
                            }}
                          >
                            {item?.scaleDescription || "--"}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>

          {/* Action Buttons */}
          {data?.responseObject?.approvalStatus !== 0 && <div className={DashboardStyle.button_cage}>
            <button
              width={"auto"}
              className={DashboardStyle?.button_cage_weight}
              onClick={handleApproveModal}
              type="button"
            >
              Approve
            </button>
            <ActionButtons
              width={"auto"}
              className={DashboardStyle?.button_cage_weight}
              style={{ backgroundColor: "red" }}
              onClick={handleDeclineModal}
              type="button"
            >
              Decline
            </ActionButtons>
          </div>}
        </FormTemplate>
      </FormProvider>
      {openDeclineModal && (
        <AppraisalDeclineModal
          openModal={openDeclineModal}
          closeModal={handleDeclineModal}
          handleComment={handleComment}
          handleDelete={() => declineAction(declineVariable)}
          isLoading={isLoading}
        />
      )}
      <ApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={() => declineAction(approveVaiable)}
        handleComment={handleComment}
        isLoading={isLoading}
        headText={"Approve Rating Scale"}
      />
    </PageLayout>
  );
};
